import React from 'react';
import clsx from 'clsx';
import Icon from '@components/atoms/icon/icon';
import styles from './field-error.module.scss';

interface FieldErrorProps extends React.HTMLAttributes<HTMLSpanElement> {
  id?: string;
}

const FieldError: React.FC<FieldErrorProps> = ({ id, className, children, ...props }) => {
  if (!children) {
    return null;
  }

  return (
    <span
      id={id}
      role="alert"
      className={clsx(styles.fieldError, className)}
      {...props}
    >
      <Icon
        name="warning-default"
        className={styles.fieldError__icon}
        ariaHidden
      />
      {children}
    </span>
  );
};

export default FieldError;
